import 'windi.css';
import '@fontsource/montserrat';

import { install as FrontendCorePlugin, vuetify } from '@anschuetz-elog/frontend-core';
import Vue, { VNode } from 'vue';

import App from '~/App.vue';
import createRouter from '~/router';

const vueOptions = {
  createRouter,
  parentRouteName: 'home',
};
Vue.use(FrontendCorePlugin, vueOptions);

vuetify.framework.theme.dark = false;

new Vue({
  ...vueOptions,
  render: (h): VNode => h(App),
}).$mount('#app');
